import React, { useRef, useState } from 'react';
import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { UploadWithBadge, SecondaryButton, PrimaryButton } from '../../../Core/FormInput';
import DialogComp from '../../../Core/Modal/dialogModal';

export const VehicleInspectionMileagePhoto = ({ state, setState, disabled }) => {
    const fileInputRef = useRef(null);
    const [previewOpen, setPreviewOpen] = useState(false);

    const hasPhoto = Boolean(state.vehicleInspectionMileagePhoto);

    const handleImageChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            const image = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                image.src = e.target.result;
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    const MAX_WIDTH = 800;
                    const MAX_HEIGHT = 800;
                    let width = image.width;
                    let height = image.height;

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width;
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width *= MAX_HEIGHT / height;
                            height = MAX_HEIGHT;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(image, 0, 0, width, height);

                    const compressedBase64 = canvas.toDataURL('image/jpeg', 0.85);
                    setState((st) => ({ ...st, vehicleInspectionMileagePhoto: compressedBase64 }));
                };
            };
            reader.readAsDataURL(file);
        }
        if (event.target) {
            event.target.value = '';
        }
    };

    const handleClick = () => {
        if (hasPhoto) {
            setPreviewOpen(true);
        } else {
            if (!disabled && fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
    };

    const handleRemove = () => {
        setState((st) => ({ ...st, vehicleInspectionMileagePhoto: '' }));
        setPreviewOpen(false);
    };

    const handleChangePhoto = () => {
        setPreviewOpen(false);
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <>
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleImageChange}
            />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <UploadWithBadge
                    isMandetory={true}
                    onClick={handleClick}
                    state={hasPhoto}
                    count={hasPhoto ? 1 : 0}
                    toolTipTitle={hasPhoto ? (disabled ? 'View Mileage Photo' : 'View / Change Mileage Photo') : (disabled ? 'Odometer Photo' : 'Upload Mileage Photo')}
                    style={{ cursor: hasPhoto || !disabled ? 'pointer' : 'default' }}
                />
            </div>
            {previewOpen && (
                <DialogComp
                    title="Odometer Reading Photo"
                    onClose={() => setPreviewOpen(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <div style={{ padding: '16px 20px' }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                background: '#f8fafc',
                                border: '1px solid #e2e8f0',
                                borderRadius: 8,
                                padding: 12,
                                minHeight: 250,
                                maxHeight: 450,
                                overflow: 'hidden'
                            }}
                        >
                            <img
                                src={state.vehicleInspectionMileagePhoto}
                                alt="Odometer Reading"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: 400,
                                    objectFit: 'contain',
                                    borderRadius: 6
                                }}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: 16,
                                paddingTop: 12,
                                borderTop: '1px solid #f1f5f9'
                            }}
                        >
                            <div>
                                {!disabled && (
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        startIcon={<DeleteIcon />}
                                        onClick={handleRemove}
                                        style={{ textTransform: 'none', fontWeight: 600, fontSize: 12 }}
                                    >
                                        Remove Photo
                                    </Button>
                                )}
                            </div>
                            <div style={{ display: 'flex', gap: 10 }}>
                                {!disabled && (
                                    <PrimaryButton
                                        size="small"
                                        startIcon={<CloudUploadIcon />}
                                        onClick={handleChangePhoto}
                                        style={{ textTransform: 'none', fontWeight: 600, fontSize: 12 }}
                                    >
                                        Change Photo
                                    </PrimaryButton>
                                )}
                                <SecondaryButton
                                    size="small"
                                    onClick={() => setPreviewOpen(false)}
                                    style={{ textTransform: 'none', fontWeight: 600, fontSize: 12 }}
                                >
                                    Close
                                </SecondaryButton>
                            </div>
                        </div>
                    </div>
                </DialogComp>
            )}
        </>
    );
};

export default VehicleInspectionMileagePhoto;
